import React from "react";

const PhysicianManagementIcon = ({ style = {} }) => {
  return (
    <svg style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7688 3.884C11.9408 4.211 12.1138 4.529 12.2778 4.928C12.6128 5.728 13.0218 6.49 13.2308 7.317C14.0108 10.504 11.4608 13.682 8.2908 13.8C8.2538 13.809 8.2178 13.809 8.1818 13.809C4.9768 13.755 2.3518 10.539 3.1418 7.317C3.3418 6.49 3.7588 5.727 4.0778 4.927C4.2498 4.51 4.4408 4.183 4.6128 3.847"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0004 12.434C21.0068 12.736 20.9529 13.0363 20.8417 13.3172C20.7306 13.5982 20.5645 13.8541 20.3532 14.07C20.1419 14.2859 19.8896 14.4574 19.6111 14.5746C19.3326 14.6917 19.0335 14.7521 18.7314 14.7521C18.4293 14.7522 18.1302 14.692 17.8517 14.5749C17.5732 14.4579 17.3208 14.2865 17.1094 14.0707C16.898 13.8549 16.7318 13.599 16.6205 13.3182C16.5092 13.0373 16.4552 12.737 16.4614 12.435C16.4614 11.833 16.7006 11.2556 17.1263 10.8299C17.552 10.4042 18.1294 10.165 18.7314 10.165C19.3335 10.165 19.9109 10.4042 20.3366 10.8299C20.7623 11.2556 21.0014 11.833 21.0014 12.435L21.0004 12.434Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7301 14.705V14.931C18.7301 16.3158 18.18 17.6439 17.2008 18.6232C16.2215 19.6024 14.8934 20.1525 13.5086 20.1525C12.1238 20.1525 10.7957 19.6024 9.81645 18.6232C8.83723 17.6439 8.28711 16.3158 8.28711 14.931V13.797"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default PhysicianManagementIcon;
